import {
  FixedAssetReceivedStateTypes,
  FixedAssetReceivedActionTypes,
} from "./FixedAssetReceived.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FixedAssetReceivedStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState(null),
  fetchReport: resetApiCallState([]),
  fetchPlateNumberList: resetApiCallState([]),
};

const FixedAssetReceivedReducer = (
  state: FixedAssetReceivedStateTypes = INITIAL_STATE,
  action: any
): FixedAssetReceivedStateTypes => {
  switch (action.type) {
    case FixedAssetReceivedActionTypes.FETCH_ALL_FIXED_ASSET_RECEIVED:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetReceivedActionTypes.FETCH_ALL_FIXED_ASSET_RECEIVED_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FixedAssetReceivedActionTypes.FETCH_ALL_FIXED_ASSET_RECEIVED_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetReceivedActionTypes.FETCH_ALL_FIXED_ASSET_RECEIVED_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ---

    case FixedAssetReceivedActionTypes.FETCH_ONE_FIXED_ASSET_RECEIVED:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: null,
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetReceivedActionTypes.FETCH_ONE_FIXED_ASSET_RECEIVED_RESET:
      return {
        ...state,
        fetchOne: resetApiCallState(null),
      };
    case FixedAssetReceivedActionTypes.FETCH_ONE_FIXED_ASSET_RECEIVED_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: null,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetReceivedActionTypes.FETCH_ONE_FIXED_ASSET_RECEIVED_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ---

    case FixedAssetReceivedActionTypes.FETCH_FIXED_ASSET_RECEIVED_REPORT:
      return {
        ...state,
        fetchReport: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetReceivedActionTypes.FETCH_FIXED_ASSET_RECEIVED_REPORT_RESET:
      return {
        ...state,
        fetchReport: resetApiCallState([]),
      };
    case FixedAssetReceivedActionTypes.FETCH_FIXED_ASSET_RECEIVED_REPORT_FAILURE:
      return {
        ...state,
        fetchReport: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetReceivedActionTypes.FETCH_FIXED_ASSET_RECEIVED_REPORT_SUCCESS:
      return {
        ...state,
        fetchReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // ---

    case FixedAssetReceivedActionTypes.FETCH_FIXED_PLATE_NUMBER_LIST:
      return {
        ...state,
        fetchPlateNumberList: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetReceivedActionTypes.FETCH_FIXED_PLATE_NUMBER_LIST_RESET:
      return {
        ...state,
        fetchPlateNumberList: resetApiCallState([]),
      };
    case FixedAssetReceivedActionTypes.FETCH_FIXED_PLATE_NUMBER_LIST_FAILURE:
      return {
        ...state,
        fetchPlateNumberList: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetReceivedActionTypes.FETCH_FIXED_PLATE_NUMBER_LIST_SUCCESS:
      return {
        ...state,
        fetchPlateNumberList: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FixedAssetReceivedReducer;
